import { useMemo } from "react";
import { useApiData } from "./useApiData";

/**
 * The warehouse list, normalized to {id, name} whether the backend returns
 * a plain array or {success, warehouses:[...]}, and whether the fields are
 * named id/warehouseid or name/naziv (three pages used to check this in
 * three different ways - the "Tabela" page did not recognize the
 * {success, warehouses} shape at all, so its dropdown stayed empty).
 */
export function useWarehouses() {
  const { data, loading, error } = useApiData("/warehouses.php");

  const warehouses = useMemo(() => {
    const list = Array.isArray(data) ? data : Array.isArray(data?.warehouses) ? data.warehouses : [];
    return list.map((w) => ({
      id: String(w.id ?? w.warehouseid ?? ""),
      name: w.name ?? w.naziv ?? "",
    }));
  }, [data]);

  return { warehouses, loading, error };
}
